export const valueAvailable = (value?: number) => !!value && value >= 1;
